import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { FAQS } from "@/lib/data";

const FAQSection = () => {
    const [open, setOpen] = useState(0);
    return (
        <section data-testid="faq-section" className="sxe-section relative">
            <div className="sxe-container">
                <div className="grid lg:grid-cols-[1fr_1.4fr] gap-12 lg:gap-20 items-start">
                    <div>
                        <div className="overline"><span className="dot" /> FAQ</div>
                        <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-medium tracking-tighter leading-[1.05] text-white mt-5">
                            Questions we{" "}
                            <span className="text-gradient">answer often</span>.
                        </h2>
                        <p className="text-[#B0A3C4] text-lg leading-relaxed mt-5">
                            Can&apos;t find what you need? Reach out to our enterprise team — we typically respond within one working day.
                        </p>
                    </div>
                    <div className="flex flex-col gap-3">
                        {FAQS.map((f, i) => (
                            <div
                                key={i}
                                className="sxe-card p-6"
                                data-testid={`faq-item-${i}`}
                            >
                                <button
                                    onClick={() => setOpen(open === i ? -1 : i)}
                                    className="w-full flex items-center justify-between text-left gap-4"
                                    data-testid={`faq-toggle-${i}`}
                                >
                                    <span className="font-display text-white text-lg font-medium tracking-tight">{f.q}</span>
                                    <span className={`shrink-0 w-8 h-8 rounded-full border ${open === i ? "border-[#C266FF] bg-[#A100FF]/15" : "border-white/10"} flex items-center justify-center text-[#E9CCFF] transition-colors`}>
                                        {open === i ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                                    </span>
                                </button>
                                <AnimatePresence initial={false}>
                                    {open === i && (
                                        <motion.div
                                            initial={{ height: 0, opacity: 0 }}
                                            animate={{ height: "auto", opacity: 1 }}
                                            exit={{ height: 0, opacity: 0 }}
                                            transition={{ duration: 0.3 }}
                                            className="overflow-hidden"
                                        >
                                            <p className="text-[#B0A3C4] text-[15px] leading-relaxed pt-4">{f.a}</p>
                                        </motion.div>
                                    )}
                                </AnimatePresence>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FAQSection;
